// extracted by mini-css-extract-plugin
export default {"icon":"fp_BLJ2FW4Oyyb0bHiD4"};